import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Fade,
  Typography,
  Box,
  Select,
  MenuItem,
  Alert,
  AlertTitle,
  Divider,
} from "@mui/material";

const TransferUsersDialog = ({
  open,
  onClose,
  loading = false,
  users = [],
  roles = [],
  selectedRole = "",
  onRoleChange,
  onConfirm,
  currentRoleId,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {loading ? "Verificando usuarios…" : "Transferencia de usuarios"}
      </DialogTitle>

      <DialogContent>
        {loading ? (
          <Fade in>
            <Box sx={{ py: 4, textAlign: "center" }}>
              <Typography color="text.secondary">
                Cargando usuarios asociados…
              </Typography>
              <Box className="loader" />
            </Box>
          </Fade>
        ) : (
          <Fade in>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              {/* ALERT PRINCIPAL */}
              <Alert severity="warning" variant="outlined">
                <AlertTitle sx={{ fontWeight: 600, m: "2px" }}>
                  ¡CUIDADO!
                </AlertTitle>
                <Box sx={{ ml: "10px" }}>
                  Este rol tiene <b>{users.length}</b> usuarios asociados.
                  <br />
                  Debes transferirlos a otro rol antes de continuar.
                </Box>
              </Alert>

              {/* LISTA DE USUARIOS */}
              <Box
                sx={{
                  maxHeight: 200,
                  overflowY: "auto",
                  bgcolor: "#fafafa",
                  border: "1px solid #e0e0e0",
                  borderRadius: 2,
                  p: 1.5,
                }}>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ mb: 1, display: "block" }}>
                  Usuarios afectados
                </Typography>

                {users.map((u) => (
                  <Typography key={u.id} variant="body2" sx={{ pl: 1 }}>
                    • {u.name} {u.surname}{" "}
                    <Typography component="span" color="text.secondary">
                      ({u.email})
                    </Typography>
                  </Typography>
                ))}
              </Box>

              <Divider />

              {/* SELECT NUEVO ROL */}
              <Box>
                <Typography variant="body2" sx={{ mb: 0.5 }}>
                  Nuevo rol destino
                </Typography>

                <Select
                  fullWidth
                  size="small"
                  value={selectedRole}
                  onChange={(e) => onRoleChange(e.target.value)}>
                  <MenuItem value="">
                    <em>Selecciona un rol</em>
                  </MenuItem>

                  {roles
                    .filter((r) => r.id !== currentRoleId)
                    .map((role) => (
                      <MenuItem key={role.id} value={role.id}>
                        {role.type}
                      </MenuItem>
                    ))}
                </Select>
              </Box>
            </Box>
          </Fade>
        )}
      </DialogContent>

      <DialogActions>
        <Button color="inherit" onClick={onClose}>
          Cancelar
        </Button>

        <Button
          variant="contained"
          color="warning"
          disabled={!selectedRole || loading}
          onClick={onConfirm}>
          Transferir usuarios
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TransferUsersDialog;
